import constants from '../../constants';
import { trackButtonClick, trackClick, trackIconClick } from './common';

/**
 * ----- Choose cabin 3.0 tracking -----
 * @link https://virginvoyages.atlassian.net/wiki/spaces/DA/pages/5179408386/VV+-+PI24+-+Choose+Cabin+3.0+Fare+Classes+Tracking
 */

/**
 * 1. Choose Cabin Page – Meta Category Selection – Filtering Price By
 */
export const onPriceToggleApply = (priceGroup: string) => {
  trackClick(constants.EVENT_ACTIONS.FILTER_APPLIED)({
    labels: ['price-by', priceGroup],
  });
};

/**
 * 3. Choose Cabin Page – Category Selection – ‘Tour This Cabin’ Icon Clicks
 */
export const onTourThisCabin = (cabinName: string) => {
  trackIconClick({
    labels: [constants.FLYOUTS.TOUR_CABIN, cabinName],
  });
};

/**
 * 4. Choose Cabin Page – Category Selection – ‘Explore’ Icon Clicks
 */
export const onExploreCabin = (cabinName: string) => {
  trackIconClick({
    labels: [constants.FLYOUTS.EXPLORE_CABIN, cabinName],
  });
};

/**
 * 5. Choose Cabin Page – Category Selection – ‘Explore’ Overlay – ‘Book This’ CTA Button Clicks
 */
export const onExploreCabinBookThis = (cabinName: string) => {
  trackButtonClick({
    flyouts: [constants.FLYOUTS.EXPLORE_CABIN],
    labels: [constants.EVENT_LABELS.BOOK_THIS, cabinName],
  });
};

/**
 * 6. Choose Cabin Page – Category Selection – ‘Explore’ Overlay – Uplift Info Clicks
 */
export const onExploreCabinUpliftInfo = (cabinName: string) => {
  trackIconClick({
    flyouts: [constants.FLYOUTS.EXPLORE_CABIN],
    labels: [constants.EVENT_LABELS.UPLIFT_INFO, cabinName],
  });
};

/**
 * 7. Choose Cabin Page – Category Selection – ‘Tour This Cabin’ Overlay – ‘Book This’ CTA Button Clicks
 */
export const onTourThisCabinBookThis = (cabinName: string) => {
  trackButtonClick({
    flyouts: [constants.FLYOUTS.TOUR_CABIN],
    labels: [constants.EVENT_LABELS.BOOK_THIS, cabinName],
  });
};

/**
 * 8. Choose Cabin Page – Category Selection – ‘Tour This Cabin’ Overlay – Uplift Info Clicks
 */
export const onTourThisCabinUpliftInfo = (cabinName: string) => {
  trackIconClick({
    flyouts: [constants.FLYOUTS.TOUR_CABIN],
    labels: [constants.EVENT_LABELS.UPLIFT_INFO, cabinName],
  });
};
